import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessibiliteComponent } from './accessibilite/accessibilite.component';
import { ForbiddenComponent } from './authentification/403.component';
import { AuthentificationGuard } from './authentification/authentification.guard';
import { RolesService } from './authentification/roles.service';
import { CanDeactivateGuard } from './saisie/can-deactivate/can-deactivate.guard';
import { FormulaireComponent } from './saisie/formulaire/formulaire.component';
import { SaisieComponent } from './saisie/saisie.component';
import { SuiviSaisieComponent } from './suivi-saisie/suivi-saisie.component';

export const routes: Routes = [
    {
        path: 'saisie',
        canActivate: [AuthentificationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: FormulaireComponent,
        children: [
            {
                path: '', component: SaisieComponent,
                data: { title: 'Saisie' }
            }
        ]
    },
    {
        path: 'suivi-saisie', component: SuiviSaisieComponent, data: { title: 'Suivi de la saisie', habilitations: [RolesService.gestionnaire.toLowerCase()] }
        , canActivate: [AuthentificationGuard]
    },
    {
        path: 'accessibilite', component: AccessibiliteComponent, data: { title: 'Declaration d\'accessibilite' }
        , canActivate: [AuthentificationGuard]
    },
    { path: 'acces-interdit', component: ForbiddenComponent, data: { title: 'Accès interdit' }, canActivate: [AuthentificationGuard] },
    { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
